import { render, staticRenderFns } from "./road.vue?vue&type=template&id=5e5aa180&scoped=true&"
import script from "./road.vue?vue&type=script&lang=js&"
export * from "./road.vue?vue&type=script&lang=js&"
import style0 from "./road.vue?vue&type=style&index=0&id=5e5aa180&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5aa180",
  null
  
)

export default component.exports